import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { RequestStatus } from 'config/constants'
import AdminAPI from 'utils/api'
import { authRequest } from 'utils/authAPI'

const initialState = {
  authCard: 'login',
  data: null,
  api: null,
  error: null,
  token: localStorage.getItem('token') ?? null,
  userLoading: false
}

export const authToken = createAsyncThunk(
  'authToken',
  async (data, thunkApi) => {
    try {
      return await authRequest(data)
    } catch (err) {
      return thunkApi.rejectWithValue(err)
    }
  }
)

export const authVerifyOtp = createAsyncThunk(
  'authVerifyOtp',
  async ({ data }, { getState, dispatch, rejectWithValue }) => {
    try {
      const token = getState().auth.token
      const api = new AdminAPI({ token, dispatch })
      const user = await api.request(
        'Api/V8/custom/portal/verify-2fa-code',
        'POST'
      )
      return { ...user, api }
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

export const fetchAuthUser = createAsyncThunk(
  'fetchAuthUser',
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const token = getState().auth.token
      const api = new AdminAPI({ token, dispatch })
      const user = await api.request('V8/custom/portal/verify-2fa-code')
      return { ...user, api }
    } catch (err) {
      return rejectWithValue(err)
    }
  }
)

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (state, { payload }) => {
      state.data = payload
    },
    setAuthCard: (state, { payload }) => {
      state.authCard = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    resetError: state => {
      state.error = null
    },
    setUserLoading: (state, { payload }) => {
      state.userLoading = payload
    },
    resetAuth: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(authToken.pending, state => {
      state.loading = RequestStatus.Pending
    })
    builder.addCase(authToken.fulfilled, (state, { payload }) => {
      state.token = payload.access_token
      state.loading = RequestStatus.Idle
      state.error = null
    })
    builder.addCase(authToken.rejected, (state, { payload }) => {
      state.loading = RequestStatus.Idle
      state.error = payload.error_description || null
    })
    builder.addCase(fetchAuthUser.pending, state => {
      state.loading = RequestStatus.Pending
    })
    builder.addCase(fetchAuthUser.fulfilled, (state, { payload }) => {
      state.api = payload?.api || null
      state.loading = RequestStatus.Idle
      state.error = null
    })
    builder.addCase(fetchAuthUser.rejected, (state, { payload }) => {
      state.loading = RequestStatus.Idle
      state.error = payload || null
    })
  }
})

export const {
  setAuthCard,
  setError,
  setUserData,
  resetError,
  setUserLoading,
  resetAuth
} = auth.actions

export const selectAuth = state => state.auth

export default auth.reducer
